import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { HeaderMainModalProps } from '@/components/AdvertisePayments/components/Header/Header.types';
import { CloseIcon } from '@/components/ui/Icons/Icons';

import * as S from './Header.styles';

export const HeaderMainModal: FC<HeaderMainModalProps> = ({
  onModalClose,
  contentTitle
}: HeaderMainModalProps) => {
  const { t } = useTranslation();

  return (
    <S.ModalHeader>
      <S.ModalTitle>{contentTitle || t('Advertise.title')}</S.ModalTitle>
      <S.ModalCloseIconButton onClick={onModalClose}>
        <CloseIcon />
      </S.ModalCloseIconButton>
    </S.ModalHeader>
  );
};
